import { lazy } from 'react'

export const GoalWeightV1 = lazy(() => import('./v1/GoalWeightV1'))
export const GoalWeightV2 = lazy(() => import('./v2/GoalWeightV2'))
export const GoalWeightV3 = lazy(() => import('./v3/GoalWeightV3'))
export const GoalWeightV4 = lazy(() => import('./v4/GoalWeightV4'))
